import { Entity } from '@backstage/catalog-model';

export const isKubernetesAvailable = (entity: Entity) => {
  const annotaions = entity?.metadata?.annotations || {};
  // Common backstage annotations are prefixed with 'backstage.io/kuberentes-'
  const k8sAnnotations = Object.keys(annotaions).find(key => key.startsWith('backstage.io/kubernetes-'))
  return !!k8sAnnotations;
};
